import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminHeader from "../../common/AdminHeader";
import { Modal, Button, Form } from "react-bootstrap";
import Footer from "../../common/Footer";
import { baseUrl } from "../../../Utility/constants";

const DisabilityTypesMaster = () => {
  const [list, setList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [model, setModel] = useState({
    id: 0,
    disabilityCode: "",
    disabilityName: "",
    isActive: 1,
  });

  const apiUrl = `${baseUrl}/api/DisabilityTypesMaster`;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await axios.get(apiUrl);
      setList(res.data);
    } catch (err) {
      toast.error("Failed to load disability types");
    }
  };

  const handleShowModal = (item = null) => {
    if (item) {
      setModel({
        id: item.id,
        disabilityCode: item.disabilityCode,
        disabilityName: item.disabilityName,
        isActive: item.isActive,
      });
      setIsEdit(true);
    } else {
      setModel({
        id: 0,
        disabilityCode: "",
        disabilityName: "",
        isActive: 1,
      });
      setIsEdit(false);
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleChange = (e) => {
    setModel({ ...model, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      if (!model.disabilityCode || !model.disabilityName) {
        toast.warning("Please fill all fields");
        return;
      }

      if (isEdit) {
        await axios.put(`${apiUrl}/${model.id}`, model);
        toast.success("Disability type updated successfully");
      } else {
        await axios.post(apiUrl, model);
        toast.success("Disability type added successfully");
      }

      fetchData();
      handleCloseModal();
    } catch (error) {
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Failed to save record");
      }
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    try {
      await axios.delete(`${apiUrl}/${id}`);
      toast.success("Record deleted successfully");
      fetchData();
    } catch (error) {
      toast.error("Failed to delete record");
    }
  };

  return (
    <>
      <AdminHeader />

      <div className="container mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>Disability Types Master</h4>
          <Button variant="primary" onClick={() => handleShowModal()}>
            Add Disability Type
          </Button>
        </div>

        <table className="table table-bordered table-striped">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Code</th>
              <th>Name</th>
              {/* <th>Status</th> */}
              <th width="160">Actions</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 && (
              <tr>
                <td colSpan="5" className="text-center">
                  No records found
                </td>
              </tr>
            )}

            {list.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.disabilityCode}</td>
                <td>{item.disabilityName}</td>
                {/* <td>
                  {item.isActive === 1 ? (
                    <span className="badge bg-success">Active</span>
                  ) : (
                    <span className="badge bg-secondary">Inactive</span>
                  )}
                </td> */}
                <td>
                  <Button
                    variant="warning"
                    size="sm"
                    className="me-2"
                    onClick={() => handleShowModal(item)}
                  >
                    Edit
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleDelete(item.id)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEdit ? "Edit Disability Type" : "Add Disability Type"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Disability Code</Form.Label>
              <Form.Control
                type="text"
                name="disabilityCode"
                value={model.disabilityCode}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Disability Name</Form.Label>
              <Form.Control
                type="text"
                name="disabilityName"
                value={model.disabilityName}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleSubmit}>
            {isEdit ? "Update" : "Save"}
          </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
      <ToastContainer />
    </>
  );
};

export default DisabilityTypesMaster;
